import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL, STORAGE_KEYS } from '../constants';
import { storage } from '../utils/storage';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      // Don't clobber an Authorization header the endpoint already set
      // (e.g. CMS mutations attach the separate CMS-admin token).
      if (!headers.has('Authorization')) {
        const token = storage.get(STORAGE_KEYS.AUTH_TOKEN);
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'Horses', 'MyHorses', 'RiderProfiles', 'BookingRequests', 'AdminHorses', 'Cms'],
  endpoints: () => ({}),
});
